import { create } from 'zustand';

export type MainViewTab = 'video' | 'map';
export type TimelineFilter = 'all' | 'ai-only';

interface UIState {
  mainViewTab: MainViewTab;
  timelineFilter: TimelineFilter;
  showIncidentReport: boolean;
  showCameraManagement: boolean;
  showWorkerManagement: boolean;
  showTaskManagement: boolean;
  setMainViewTab: (tab: MainViewTab) => void;
  setTimelineFilter: (filter: TimelineFilter) => void;
  setShowIncidentReport: (show: boolean) => void;
  setShowCameraManagement: (show: boolean) => void;
  setShowWorkerManagement: (show: boolean) => void;
  setShowTaskManagement: (show: boolean) => void;
}

export const useUIStore = create<UIState>((set) => ({
  mainViewTab: 'video',
  timelineFilter: 'all',
  showIncidentReport: false,
  showCameraManagement: false,
  showWorkerManagement: false,
  showTaskManagement: false,
  setMainViewTab: (tab) => set({ mainViewTab: tab }),
  setTimelineFilter: (filter) => set({ timelineFilter: filter }),
  setShowIncidentReport: (show) => set({ showIncidentReport: show }),
  setShowCameraManagement: (show) => set({ showCameraManagement: show }),
  setShowWorkerManagement: (show) => set({ showWorkerManagement: show }),
  setShowTaskManagement: (show) => set({ showTaskManagement: show }),
}));
